import React, { useEffect, useRef, useState } from 'react';
import '../styles/AboutUsPage.css';
import { Link } from 'react-router-dom';
import image from '../assets/image.jpg'
import heroImg from '../assets/hero.svg';
import image1 from '../assets/image2.jpg'
import image2 from '../assets/image4.jpg'
import pic_1 from '../assets/stock-1.png'
import pic_2 from '../assets/stock-2.png'
import pic_3 from '../assets/stock-3.png'
import pic_4 from '../assets/stock-4.png'
import pic_5 from '../assets/stock-5.png'
import pic_6 from '../assets/stock-6.png'
import pic_7 from '../assets/image.jpg'
import pic_8 from '../assets/stock-8.png'
import pic_9 from '../assets/stock-9.jpg'
import pic_10 from '../assets/stock-10.jpg'
import pic_11 from '../assets/stock-11.png'

const allImages = [image1, image2, image, heroImg, pic_1, pic_2, pic_3, pic_4, pic_5, pic_6, pic_7, pic_8,
  pic_9, pic_10, pic_11, heroImg, image1, image2, pic_1, pic_2, pic_3, pic_4, pic_5, pic_6,
  pic_7, pic_8, pic_9, pic_10, pic_11, image2, image1, pic_1, pic_2, heroImg, image, pic_3,
  pic_4, pic_5, pic_6, pic_7, pic_8, pic_9, pic_10, pic_11, image, heroImg, image1, image2
];

const AboutUsPage: React.FC = () => {
  const galleryRef = useRef<HTMLDivElement>(null);
  const [chunkSize, setChunkSize] = useState(1);

  // Update chunk size based on screen width
  const updateChunkSize = () => {
    const width = window.innerWidth;
    if (width >= 1024) return 9;
    if (width >= 780) return 4;
    return 1;
  };

  useEffect(() => {
    const handleResize = () => setChunkSize(updateChunkSize());
    setChunkSize(updateChunkSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Split images into chunks
  const chunkedImages = [];
  for (let i = 0; i < allImages.length; i += chunkSize) {
    chunkedImages.push(allImages.slice(i, i + chunkSize));
  }

  const scroll = (dir: number) => {
    const container = galleryRef.current;
    if (!container) return;
    const width = container.clientWidth;
    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - width;

    const newScroll = dir === 1
      ? (scrollLeft + width >= maxScroll ? 0 : scrollLeft + width)
      : (scrollLeft - width <= 0 ? maxScroll : scrollLeft - width);

    container.scrollTo({ left: newScroll, behavior: 'smooth' });
  };


  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 100); 

    return () => clearTimeout(timeout);
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-us-page py-10 p-8 md:p-12">
      <div className="aboutUs">
        <div className="aboutUs-text">
          <h2 className="text-4xl md:text-5xl font-bold animate-fade-in">
            About Us
          </h2>
          <div>
            <p>
              Bring on Your Technology Challenges
              At Betaque, we believe that complex infrastructure problems are opportunities for innovation. 
              We tackle the toughest DevOps, cloud, and SRE challenges head-on, delivering solutions that 
              transform how teams build, deploy, and operate at scale.
            </p>
          </div>
        </div>
      </div>

      {/* who we are */}
      <div className={`about-company ${isVisible ? "visible" : ""}`}>
      <div className="image-column">
          <div className="main-image">
            <img src={pic_1} alt="img" />
          </div>
          <div className="overlay-image">
            <img src={heroImg} alt="img" />
          </div>
        </div>
        <div className="text-column">
            <h3 className="sections-title">Who We Are</h3>
            <p className="story-text">
              Betaque is a premier cloud-native services firm founded to help organizations accelerate their digital transformation journeys. 
              Our team of seasoned engineers, architects, and DevOps experts partners with clients to design, build, and manage scalable, secure, 
              and cost-effective infrastructure solutions across AWS, Google Cloud, Azure, Digital Ocean and on-premises environments.
            </p>
            <p className="story-text">
              With a passion for automation, best practices, and continuous improvement, Betaque delivers end-to-end services—from initial 
              assessment through long-term support—ensuring our clients achieve tangible business outcomes and maintain a competitive edge.
            </p>
        </div>
      </div>

      {/* why company exist */}
      <div className={`about-company ${isVisible ? "visible" : ""}`}>
      <div className="text-column">
            <h3 className="sections-title">Why Betaque Exists</h3>
            <p className="story-text">
            We founded Betaque when we saw teams struggling to maintain brittle, manually managed environments. 
            Instead of piecemeal support, clients needed a partner who could truly embed in their workflows—co-owning 
            problems as if we were part of their engineering team.
            </p>
            <p className="story-text">
            Drawing on years of experience architecting multi-cloud infrastructures and large-scale SRE systems, 
            we built Betaque to fill that gap. Today, our mission is simple: treat infrastructure as code, automate aggressively, 
            and empower organizations to focus on innovation rather than firefighting.
          </p>
        </div>
        <div className="image-column-2">
          <div className="main-image-2">
            <img src={image1} alt="img" />
          </div>
          <div className="overlay-image-2">
            <img src={image2} alt="img" />
          </div>
        </div>
      </div>

       {/* Company Story */}
       <div className={`about-company ${isVisible ? "visible" : ""}`}>
       <div className="image-column">
          <div className="main-image">
            <img src={pic_2} alt="img" />
          </div>
          <div className="overlay-image">
            <img src={pic_8} alt="img" />
          </div>
        </div>
        <div className="text-column">
            <h3 className="sections-title">Our Story</h3>
            <p className="story-text">
              Founded by a group of cloud and DevOps veterans, Betaque was born out of a shared belief: traditional IT 
              processes were not keeping pace with the demands of modern applications. We recognized early on that organizations 
              needed more than just advisory—they needed hands-on execution, templates that work at scale, and a partner who 
              understood the daily pressures DevOps teams face.
            </p>
            <p className="story-text">
            Over the years, Betaque has grown from a small consultancy into a multi-disciplinary team, delivering hundreds of 
              successful engagements spanning global cloud migrations, high-availability Kubernetes deployments, and fully automated 
              CI/CD pipelines. Our track record of turning complex requirements into reliable, automated solutions has earned our 
              clients' trust and driven our sustained growth.
            </p>
        </div>
      </div>

      {/* Mission & Vision */}
      <div className="mission-vision-section">
        <div className="mission-vision-card">
        <div className="mission-vision-card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" 
              width="24" height="24" viewBox="0 0 24 24" 
              fill="none" stroke="currentColor" 
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="6" />
            <circle cx="12" cy="12" r="2" />
          </svg>
        </div>
          <h3 className="card-title">Our Mission</h3>
          <p className="card-text">
            To empower organizations through innovative technology solutions that transform operations,
            enhance user experiences, and drive sustainable growth.
          </p>
        </div>
        <div className="mission-vision-card">
          <div className="mission-vision-card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </div>
          <h3 className="card-title">Our Vision</h3>
          <p className="card-text">
            To be the leading technology partner for forward-thinking organizations, known for our technical
            excellence, impactful solutions, and exceptional client partnerships.
          </p>
        </div>
      </div>

      {/* Core Values */}
      <div className="core-values-section">
        <h3 className="sections-title">Our Core Values</h3>
        <div className="values-container">
          <div className="value-card">
            <span className="value-number">01</span>
            <h4 className="value-title">Craftsmanship Over Convenience</h4>
            <p className="value-description">
              We maintain a growth mindset and insist on writing clean, maintainable infrastructure code—whether 
              it's defining environments, creating configuration manifests, or orchestrating deployments.
            </p>
          </div>

          <div className="value-card">
            <span className="value-number">02</span>
            <h4 className="value-title">Be the Reliable Backbone</h4>
            <p className="value-description">
              Dependability is non-negotiable. We show up consistently, anticipate risks, and drive projects 
              forward even when the path isn't clear.
            </p>
          </div>

          <div className="value-card">
            <span className="value-number">03</span>
            <h4 className="value-title">Hustle with Humility</h4>
            <p className="value-description">
              We tackle complex challenges with determination, but never lose sight of collaboration and respect. 
              Ego has no place in problem-solving.
            </p>
          </div>

          <div className="value-card">
            <span className="value-number">04</span>
            <h4 className="value-title">Security by Default</h4>
            <p className="value-description">
              Every design, every automation script, and every deployment follows the principle of least privilege. 
              We embed compliance checks into our workflows so you're audit-ready from day one.
            </p>
          </div>
        </div>
      </div>

      {/* Our Embedded "BetaPods" Model */}
      <div className="core-values-section">
        <h3 className="sections-title">Our Embedded "BetaPods" Model</h3>
        <div className=" values-container model-values-container">
          <div className="model-card">
            <h4 className="model-title">Seamless Integration</h4>
            <p className="value-description">
              We assign a small, dedicated team of experts—our "BetaPods"—to work alongside your engineers.
            </p>
          </div>

          <div className="model-card">
            <h4 className="model-title">Co-Ownership of Outcomes</h4>
            <p className="value-description">
              BetaPods adopt your processes and standards, sharing responsibility for design reviews, change management, and incident response.
            </p>
          </div>

          <div className="model-card">
            <h4 className="model-title">Rapid Value Delivery</h4>
            <p className="value-description">
              By aligning directly with your sprint cycles and release cadences, BetaPods accelerate time to ROI—often delivering production-ready infrastructure in weeks, not months.
            </p>
          </div>
        </div>
      </div>

      {/* Life at betaque */}
      <div className="gallery-heading">
        <h3 className="gallery-title">Life At Betaque</h3>
      </div>
      <div className="gallery-container">
        <button className="side-button prev" onClick={() => scroll(-1)}>
          &#10094;
        </button>
        
        <div className="gallery" ref={galleryRef}>
          {chunkedImages.map((chunk, i) => (
            <div className="gallery-item" key={i}>
              {chunk.map((img, j) => (
                <div className="image-box" key={j}>
                <img src={img} alt={`img-${i}-${j}`} />
                </div>            
              ))}
            </div>
          ))}
        </div>
        <button className="side-button next" onClick={() => scroll(1)}>
          &#10095;
        </button>
      </div>

    </div>
  );
};

export default AboutUsPage; 